import { __assign, __rest } from "tslib";
import React from 'react';
import { Wrapper, Text, Triangle } from './tooltip.style';
export var Tooltip = function (_a) {
    var text = _a.text, _b = _a.placement, placement = _b === void 0 ? 'top' : _b, children = _a.children, _c = _a.className, className = _c === void 0 ? '' : _c, props = __rest(_a, ["text", "placement", "children", "className"]);
    return (React.createElement(Wrapper, __assign({ className: "legion-tooltip ".concat(className) }, props),
        React.createElement(Text, { placement: placement },
            React.createElement(Triangle, { placement: placement }),
            " ",
            text),
        children));
};
